

































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import Editor from '@tinymce/tinymce-vue';

class Campaign{
  campaign_id!:number;
  title!:string;
  description!:string;
  no!:number;
  campaign_product!:number;
  enabled!:number;
  image_url:String | undefined ="";
  file!:File;
}

@Component({
    components: {
      ImageUpload,
        Decimal,
        EnabledSwitch,
        DeleteButton,EForm,Number,TextField,Id,Editor
    }
})
export default class Cargo extends  Vue{
    items : Campaign[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    campaign_product: number = 0;
    baseAction:string = "campaign";
    action:string = this.baseAction;
    data : Campaign = new Campaign();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "campaign_id"
        },
        {text: "Başlık", value: "title"},
        {text: "Sıra", value: "no"},
        {text: "Aktif", value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:Campaign){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.campaign_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new Campaign();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
